<template>
  <div v-if="item" class="absolute-form">
    <v-card>
      <v-card-title>
        Edit item
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Title"
              v-model.trim="item.title"
              type="text"
              required
              :hide-details="true"
              color="amber"
            ></v-text-field>
            <v-textarea
              label="Description"
              auto-grow
              v-model.trim="item.description"
              type="text"
              required
              :hide-details="true"
              color="amber"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-simple-table dark class="">
              <template v-slot:default>
                <UnitScaleHeader :min="min" :max="max" />
                <tbody>
                  <UnitScaleRow
                    :from="axis1.from"
                    :to="axis1.to"
                    :min="min"
                    :max="max"
                    v-model="item.scale.axis1"
                  />
                  <UnitScaleRow
                    :from="axis2.from"
                    :to="axis2.to"
                    :min="min"
                    :max="max"
                    v-model="item.scale.axis2"
                  />
                </tbody>
              </template>
            </v-simple-table>
            <div class="mt-10">
              <v-btn light class="amber" @click="$emit('close')">Done</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// const fb = require("@/firebaseConfig.js");

import { UnitScaleHeader, UnitScaleRow } from '@/components/units'

export default {
  name: 'UserCompetitionForm',
  data() {
    return {
      item: this.value,
      min: -10,
      max: 10
    }
  },
  components: {
    UnitScaleHeader,
    UnitScaleRow
  },
  props: {
    value: Object,
    axis1: {
      type: Object,
      default: () => ({
        from: '',
        to: ''
      })
    },
    axis2: {
      type: Object,
      default: () => ({
        from: '',
        to: ''
      })
    }
  },
  watch: {
    item: {
      deep: true,
      handler(val) {
        this.$emit('input', val)
        this.$emit('update', val)
      }
    },
    value(val) {
      this.item = val
    }
  }
}
</script>

<style>
.absolute-form {
  position: absolute;
  width: 75vh;
  top: 0;
  left: 0;
  z-index: 10;
}
</style>
